var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame pb-0"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col"},[_c('calculation-request-form')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }